program login_Project;

uses
  Vcl.Forms,
  WEBLib.Forms,
  login_Unit1 in 'login_Unit1.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm1, Form1);
  Application.Run;
end.
